import firebase from "firebase/app";
import "firebase/firestore";

export function initializeFirebase() {
  if (firebase.apps.length > 0) {
    return firebase.app();
  }
  const app = firebase.initializeApp({
    apiKey: process.env["NEXT_PUBLIC_FIREBASE_API_KEY"],
    authDomain: process.env["NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN"],
    databaseURL: process.env["NEXT_PUBLIC_FIREBASE_DATABASE_URL"],
    projectId: process.env["NEXT_PUBLIC_FIREBASE_PROJECT_ID"],
    storageBucket: process.env["NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET"],
    messagingSenderId: process.env["NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID"],
    appId: process.env["NEXT_PUBLIC_FIREBASE_APP_ID"],
  });
  if (process.env["NEXT_PUBLIC_APP_ENV"] === "development") {
    app.firestore().settings({
      host: process.env["NEXT_PUBLIC_FIRESTORE_HOST"],
      ssl: false,
    });
  } else if (process.env["NEXT_PUBLIC_APP_ENV"] === "test") {
    app.firestore().settings({
      experimentalForceLongPolling: true,
    });
    app
      .firestore()
      .useEmulator(
        process.env["NEXT_PUBLIC_FIREBASE_FIRESTORE_EMULATOR_HOST"],
        parseInt(process.env["NEXT_PUBLIC_FIREBASE_FIRESTORE_EMULATOR_PORT"])
      );
    app
      .auth()
      .useEmulator(process.env["NEXT_PUBLIC_FIREBASE_AUTH_EMULATOR_URL"]);
  }
  return app;
}
